import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface DetailsFieldProps {
  label: string;
  value: string;
}

const DetailField: FC<DetailsFieldProps> = ({ label, value }) => (
  <Stack>
    <Typography
      sx={(theme) => ({
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: theme.typography.body2.lineHeight,
      })}
    >
      {value}
    </Typography>
    <Typography
      sx={(theme) => ({
        fontSize: theme.typography.caption,
      })}
    >
      {label}
    </Typography>
  </Stack>
);

export default DetailField;
